import React from 'react';
import PropTypes from 'prop-types';

// Components
import WidgetOption from './WidgetOption';

// Presentational Component
const WidgetOptions = ({ widget }) => (
	<div className="widget-options">
		<h3 id={`${widget.name}-options`}>Options</h3>
		<p>Options can be passed via data attributes or JavaScript. For data attributes, append the option name to <code>data-voicestorm-</code>, as in <code>data-voicestorm-option="value"</code>.</p>
		<div className='data-table-responsive'>
			<table className="table table-bordered table-striped js-options-table">
				<thead>
					<tr>
						<th>Name</th>
						<th>Type</th>
						<th>Default</th>
						<th>Description</th>
					</tr>
				</thead>
				<tbody>
					{
						widget.options.map(option =>
							<WidgetOption key={option.name} option={option} />
						)
					}
				</tbody>
			</table >
		</div>
	</div>
);

WidgetOptions.propTypes = {
	widget: PropTypes.object.isRequired
};

export default WidgetOptions;



// WEBPACK FOOTER //
// ./src/components/widgets/WidgetOptions.js